import API from "../../api/apiUser";

export const ShopService = {
    /**
     * Fetch products with pagination and filters
     * @param {Object} params - { page, per_page, category_type, category_id, search }
     */
    getProducts: async (params = {}) => {
        try {
            const response = await API.get("/user/shop/products", { params });
            return response.data;
        } catch (error) {
            console.error("Failed to fetch products:", error);
            throw error;
        }
    },

    /**
     * Fetch a single product by ID
     * @param {string} productId
     */
    getProductById: async (productId) => {
        try {
            const response = await API.get(`/user/shop/products/${productId}`);
            return response.data;
        } catch (error) {
            console.error("Failed to fetch product details by ID:", error);
            throw error;
        }
    },

    /**
     * Fetch a single product by Slug
     * @param {string} slug
     */
    getProductBySlug: async (slug) => {
        try {
            const response = await API.get(`/user/shop/products/${slug}`);
            return response.data;
        } catch (error) {
            console.error("Failed to fetch product details by slug:", error);
            throw error;
        }
    },

    /**
     * Fetch all active categories
     */
    getCategories: async () => {
        try {
            const response = await API.get("/user/shop/categories");
            return response.data;
        } catch (error) {
            console.error("Failed to fetch categories:", error);
            throw error;
        }
    },
    /**
     * Initialize checkout (get reference and validate cart)
     * @param {Array} cart - Current cart items
     */
    initCheckout: async (cart) => {
        try {
            const response = await API.post("/user/checkout/init/", { cart });
            return response.data;
        } catch (error) {
            console.error("Failed to initialize checkout:", error);
            throw error;
        }
    },

    /**
     * Check if email exists
     * @param {string} email
     */
    checkEmail: async (email) => {
        try {
            const response = await API.post("/user/checkout/check-email/", { email });
            return response.data;
        } catch (error) {
            console.error("Failed to check email:", error);
            throw error;
        }
    },

    /**
     * Send OTP to email
     * @param {string} email
     */
    sendOtp: async (email) => {
        try {
            const response = await API.post("/user/checkout/send-otp/", { email });
            return response.data;
        } catch (error) {
            console.error("Failed to send OTP:", error);
            throw error;
        }
    },

    /**
     * Verify OTP
     * @param {string} email
     * @param {string} otp
     */
    verifyOtp: async (email, otp) => {
        try {
            const response = await API.post("/user/checkout/verify-otp/", { email, otp });
            return response.data;
        } catch (error) {
            console.error("Failed to verify OTP:", error);
            throw error;
        }
    },

    /**
     * Submit checkout form
     * @param {Object} data - { reference, email, full_name, address, cart, is_new_user }
     */
    submitCheckout: async (data) => {
        try {
            const response = await API.post("/user/checkout/submit/", data);
            return response.data;
        } catch (error) {
            console.error("Failed to submit checkout:", error);
            throw error;
        }
    },
    /**
     * Cancel checkout and remove pending order
     * @param {string} reference
     */
    cancelCheckout: async (reference) => {
        try {
            const response = await API.post("/user/checkout/cancel/", { reference });
            return response.data;
        } catch (error) {
            console.error("Failed to cancel checkout:", error);
            throw error;
        }
    },

    /**
     * Get the absolute URL for a product audio preview
     * @param {string} productId 
     */
    getAudioPreviewUrl: (productId) => {
        const baseURL = API.defaults.baseURL.replace(/\/api\/v1\/?$/, "");
        return `${baseURL}/api/v1/user/shop/products/${productId}/preview`;
    }
};
